function animateRadial(current,max,bar) {
    var $progress = Math.min(current / max,1);
    bar.animate($progress);  // Number from 0.0 to 1.0
}